export default class 在庫場所選択型 {
  部署コード: string;
  確定済: boolean;

  管理者である: boolean;
  代行ログインである: boolean;

  constructor(部署コード: string, 管理者である: boolean, 代行ログインである: boolean) {
    this.部署コード = 部署コード;
    this.管理者である = 管理者である;
    this.代行ログインである = 代行ログインである;
    if (管理者である || 代行ログインである) {
      this.確定済 = false;
    } else {
      this.確定済 = true;
    }
  }

  確定する() {
    this.確定済 = true;
  }
}
